/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ appName: NonNullable<unknown> }} Components_Clientbanner_Heading1Inputs */

const id_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dukung database build ${i?.appName}`)
};

const ms_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kuasa pangkalan data binaan ${i?.appName}`)
};

const da_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Støt ${i?.appName} builds-databasen`)
};

const de_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unterstützen Sie die ${i?.appName}-Builds-Datenbank`)
};

const en_us2_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Power the ${i?.appName} builds database`)
};

const es_es2_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Potencia la base de datos de compilaciones de ${i?.appName}`)
};

const es_mx2_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impulsa la base de datos de compilaciones de ${i?.appName}`)
};

const fil_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Palakasin ang ${i?.appName} builds database`)
};

const fr_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alimentez la base de données de compilations de ${i?.appName}`)
};

const it_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alimenta il database build di ${i?.appName}`)
};

const hu_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tápláld a ${i?.appName} build adatbázist`)
};

const nl_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voed de ${i?.appName} builds-database`)
};

const no_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Styrk ${i?.appName} builds-databasen`)
};

const pl_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wspomóż bazę kompilacji ${i?.appName}`)
};

const pt_br2_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Power the ${i?.appName} builds database`)
};

const pt_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alimente a base de dados de compilações do ${i?.appName}`)
};

const ro_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alimentează baza de date de compilări ${i?.appName}`)
};

const fi_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tehosta ${i?.appName}-koontiversioiden tietokantaa`)
};

const sv_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Driv ${i?.appName}s byggdatabas`)
};

const vi_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cung cấp sức mạnh cho cơ sở dữ liệu bản dựng ${i?.appName}`)
};

const tr_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.appName} yapı veritabanına güç verin`)
};

const cs_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pohánějte databázi sestavení ${i?.appName}`)
};

const bg_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Подхранвайте базата данни ${i?.appName}`)
};

const ru_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Подпитывайте базу данных сборок ${i?.appName}`)
};

const uk_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Підтримуйте базу збірок ${i?.appName}`)
};

const ar_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`دعم قاعدة بيانات بنيات ${i?.appName}`)
};

const hi_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.appName} बिल्ड डेटाबेस को शक्ति दें`)
};

const th_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เสริมพลังฐานข้อมูลบิลด์ ${i?.appName}`)
};

const ja_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.appName} ビルドデータベースを強化`)
};

const zh_cn2_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Power the ${i?.appName} builds database`)
};

const zh_hant1_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Power the ${i?.appName} builds database`)
};

const ko_components_clientbanner_heading1 = /** @type {(inputs: Components_Clientbanner_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Power the ${i?.appName} builds database`)
};

/**
* | output |
* | --- |
* | "Power the {appName} builds database" |
*
* @param {Components_Clientbanner_Heading1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_clientbanner_heading1 = /** @type {((inputs: Components_Clientbanner_Heading1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Clientbanner_Heading1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_clientbanner_heading1(inputs)
	if (locale === "ms") return ms_components_clientbanner_heading1(inputs)
	if (locale === "da") return da_components_clientbanner_heading1(inputs)
	if (locale === "de") return de_components_clientbanner_heading1(inputs)
	if (locale === "en-US") return en_us2_components_clientbanner_heading1(inputs)
	if (locale === "es-ES") return es_es2_components_clientbanner_heading1(inputs)
	if (locale === "es-MX") return es_mx2_components_clientbanner_heading1(inputs)
	if (locale === "fil") return fil_components_clientbanner_heading1(inputs)
	if (locale === "fr") return fr_components_clientbanner_heading1(inputs)
	if (locale === "it") return it_components_clientbanner_heading1(inputs)
	if (locale === "hu") return hu_components_clientbanner_heading1(inputs)
	if (locale === "nl") return nl_components_clientbanner_heading1(inputs)
	if (locale === "no") return no_components_clientbanner_heading1(inputs)
	if (locale === "pl") return pl_components_clientbanner_heading1(inputs)
	if (locale === "pt-BR") return pt_br2_components_clientbanner_heading1(inputs)
	if (locale === "pt") return pt_components_clientbanner_heading1(inputs)
	if (locale === "ro") return ro_components_clientbanner_heading1(inputs)
	if (locale === "fi") return fi_components_clientbanner_heading1(inputs)
	if (locale === "sv") return sv_components_clientbanner_heading1(inputs)
	if (locale === "vi") return vi_components_clientbanner_heading1(inputs)
	if (locale === "tr") return tr_components_clientbanner_heading1(inputs)
	if (locale === "cs") return cs_components_clientbanner_heading1(inputs)
	if (locale === "bg") return bg_components_clientbanner_heading1(inputs)
	if (locale === "ru") return ru_components_clientbanner_heading1(inputs)
	if (locale === "uk") return uk_components_clientbanner_heading1(inputs)
	if (locale === "ar") return ar_components_clientbanner_heading1(inputs)
	if (locale === "hi") return hi_components_clientbanner_heading1(inputs)
	if (locale === "th") return th_components_clientbanner_heading1(inputs)
	if (locale === "ja") return ja_components_clientbanner_heading1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_clientbanner_heading1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_clientbanner_heading1(inputs)
	return ko_components_clientbanner_heading1(inputs)
});
export { components_clientbanner_heading1 as "components.clientBanner.heading" }